import { useContentGeneration } from './useContentGeneration';

/**
 * Custom hook for transcription generation functionality (mirror of keyword).
 * Wraps useContentGeneration with transcription-specific naming.
 */
export const useTranscriptionGeneration = () => {
  const baseHook = useContentGeneration('transcription', 'keywords');

  return {
    transcriptionYoutubeUrl: baseHook.youtubeUrl,
    youtubeVideoInfo: baseHook.youtubeVideoInfo,
    extractingVideoInfo: baseHook.extractingVideoInfo,
    generatedTranscription: baseHook.generatedContent,
    currentTranscriptionProjectId: baseHook.currentProjectId,
    generatingTranscription: baseHook.generatingContent,
    transcriptionPrompt: baseHook.prompt,
    transcriptionPromptVersion: baseHook.promptVersion,
    transcriptionPromptTotalVersions: baseHook.promptTotalVersions,
    selectedPromptId: baseHook.selectedPromptId,
    selectedPromptVersionForUse: baseHook.selectedPromptVersionForUse,
    isEditingTranscriptionPrompt: baseHook.isEditingPrompt,
    editedTranscriptionPrompt: baseHook.editedPrompt,
    transcriptionPromptLoading: baseHook.promptLoading,

    setTranscriptionYoutubeUrl: baseHook.setYoutubeUrl,
    setYoutubeVideoInfo: baseHook.setYoutubeVideoInfo,
    setExtractingVideoInfo: baseHook.setExtractingVideoInfo,
    setGeneratedTranscription: baseHook.setGeneratedContent,
    setCurrentTranscriptionProjectId: baseHook.setCurrentProjectId,
    setGeneratingTranscription: baseHook.setGeneratingContent,
    setTranscriptionPrompt: baseHook.setPrompt,
    setTranscriptionPromptVersion: baseHook.setPromptVersion,
    setTranscriptionPromptTotalVersions: baseHook.setPromptTotalVersions,
    setSelectedPromptId: baseHook.setSelectedPromptId,
    setSelectedPromptVersionForUse: baseHook.setSelectedPromptVersionForUse,
    setIsEditingTranscriptionPrompt: baseHook.setIsEditingPrompt,
    setEditedTranscriptionPrompt: baseHook.setEditedPrompt,
    setTranscriptionPromptLoading: baseHook.setPromptLoading,

    extractYoutubeVideoInfo: baseHook.extractYoutubeVideoInfo,
    generateTranscriptionFromDescription: baseHook.generateContentFromDescription,
    fetchTranscriptionPrompt: baseHook.fetchPrompt,
    fetchTranscriptionPromptVersion: baseHook.fetchPromptVersion,
    handleTranscriptionPromptVersionChange: baseHook.handlePromptVersionChange,
    clearTranscriptionState: baseHook.clearState,
    saveTranscriptionPrompt: baseHook.savePrompt,
  };
};
